import styled from 'styled-components/native';
import Colors from './colors';

const getFontFamily = () => {
  return '"Source Sans 3", "Segoe UI", "Helvetica Neue", sans-serif';
};

const BaseText = styled.Text`
  font-family: ${getFontFamily()};
  color: ${Colors.TEXT};
`;

const Normal = styled.Text`
  font-family: ${getFontFamily()};
  font-size: 14px;
  font-weight: normal;
  color: ${Colors.TEXT};
`;

const Italic = styled(Normal)`
  font-style: italic;
`;

const Bold = styled(Normal)`
  font-weight: 700;
`;

const Heading1 = styled(BaseText)`
  font-size: 40px;
  font-weight: 700;
`;

const Heading2 = styled(BaseText)`
  font-size: 30px;
  font-weight: 700;
`;

const Heading3 = styled(BaseText)`
  font-size: 28px;
  font-weight: 700;
`;

const Heading4 = styled(BaseText)`
  font-size: 24px;
  font-weight: 700;
`;

const Heading5 = styled(BaseText)`
  font-size: 22px;
  font-weight: 700;
`;

const Heading6 = styled(BaseText)`
  font-size: 20px;
  font-weight: 700;
`;

const Title1 = styled(BaseText)`
  font-size: 20px;
  font-weight: 600;
`;

const Title2 = styled(BaseText)`
  font-size: 18px;
  font-weight: 600;
`;

const Title3 = styled(BaseText)`
  font-size: 16px;
`;

const Title4 = styled(BaseText)`
  font-size: 14px;
`;

const Title5 = styled(BaseText)`
  font-size: 12px;
`;

const basedTexts = {
  Normal,
  Italic,
  Bold,
  Heading1,
  Heading2,
  Heading3,
  Heading4,
  Heading5,
  Heading6,
  Title1,
  Title2,
  Title3,
  Title4,
  Title5,
};

const applied = {};

export default {
  ...basedTexts,
  ...applied,
};
